// Add your custom JS here.

// Handle the opening and closing of the mobile menu
const mobileMenu = document.getElementById('mobile-nav');
document.getElementById('open-mobile-nav').addEventListener('click', () => {
    mobileMenu.classList.add('open');
});
document.getElementById('close-mobile-nav').addEventListener('click', () => {
    mobileMenu.classList.remove('open');
});


/**
 * Initialise Swiper for all sliders on the site
 */
document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper === 'undefined') return;

    const sliders = document.querySelectorAll('[data-slider]');

    sliders.forEach(sliderEl => {
        const mode = sliderEl.getAttribute('data-slides-per-view');

        const totalSlides = sliderEl.querySelectorAll('.swiper-slide').length;

        const swiperOptions = {
            loop: false,
            spaceBetween: 20,
            slidesPerView: 1, // default fallback
            pagination: {
                el: sliderEl.querySelector('.swiper-pagination'),
                clickable: true
            },
            navigation: {
                nextEl: sliderEl.querySelector('.swiper-button-next'),
                prevEl: sliderEl.querySelector('.swiper-button-prev')
            },
            watchOverflow: true,
            on: { // Call the height equalisation function
                init(swiper) {
                    equaliseSwiperSlideHeights(swiper);
                    assignSliderInnerLayouts(swiper);

                    handleAlignmentAndPagination(swiper);
                },
                resize(swiper) {
                    equaliseSwiperSlideHeights(swiper);
                    assignSliderInnerLayouts(swiper);

                    handleAlignmentAndPagination(swiper);
                }
            }
        };

        // Override with responsive config if not locked to 1
        // if (mode !== '1') {
            // swiperOptions.breakpoints = {
            //     576: { slidesPerView: 1.5 },
            //     768: { slidesPerView: 2 },
            //     992: { slidesPerView: 3 },
            //     1200: { slidesPerView: 4 }
            // };
        // }
        let parsedSlidesTotal = parseInt(mode, 10);
        if( isNaN(parsedSlidesTotal) ) {
            swiperOptions.breakpoints = {
                1200: { slidesPerView: 4 },
                992: { slidesPerView: 3 },
                768: { slidesPerView: 2 },
                576: { slidesPerView: 1.5 }
            };
        } else {
            let totalSwiperSlides = Math.max(parsedSlidesTotal, 3);
            swiperOptions.breakpoints = {
                1200: { slidesPerView: Math.max(totalSwiperSlides, 1.5) },
                992: { slidesPerView: Math.max(totalSwiperSlides - 1, 1.5) },
                768: { slidesPerView: Math.max(totalSwiperSlides - 2, 1.5) },
                576: { slidesPerView: 1.5 }
            };
        }

        let swiperInstance = new Swiper(sliderEl, swiperOptions);

        // Additional function to readjust horizntal alignment of the swiper and visibility of its controls
        function handleAlignmentAndPagination(swiper) {
            const slidesPerView = swiper.params.slidesPerView;
            
            if (totalSlides <= slidesPerView) {
                // Center align the slider if fewer slides than visible
                swiper.el.querySelector('.swiper-wrapper').style.justifyContent = 'center';
        
                // Hide pagination and navigation if all slides are visible
                swiper.pagination.el.style.display = 'none';
                swiper.navigation.nextEl.style.display = 'none';
                swiper.navigation.prevEl.style.display = 'none';
            } else {
                // Reset to default alignment and show controls
                swiper.el.querySelector('.swiper-wrapper').style.justifyContent = 'flex-start';
                swiper.pagination.el.style.display = 'block';
                swiper.navigation.nextEl.style.display = 'block';
                swiper.navigation.prevEl.style.display = 'block';
            }
            swiper.update();
        }

        // Ensure alignment is checked when the window resizes
        window.addEventListener('resize', () => {
            handleAlignmentAndPagination(swiperInstance);
        });
    });
});
// Additional function to make all slides match the height of the tallest one
function equaliseSwiperSlideHeights(swiperInstance) {
    let maxHeight = 0;
    swiperInstance.slides.forEach(slide => {
        slide.style.height = 'auto'; // Reset
        maxHeight = Math.max(maxHeight, slide.offsetHeight);
    });
    swiperInstance.slides.forEach(slide => {
        slide.style.height = maxHeight + 'px';
    });
}
// Additional function to set vertical alignment inside an individual slide based on number of items in the slide
function assignSliderInnerLayouts(swiperInstance) {
    swiperInstance.slides.forEach(slide => {
        const content = Array.from(slide.children).filter(el => el.nodeType ===1);
        slide.classList.remove('layout-centered', 'layout-spaced');

        if(content.length ===1) {
            slide.classList.add('layout-centered');
        } else {
            slide.classList.add('layout-spaced');
        }
    })
}
  

/**
 * Custom JS for sliding tabbed sections
 */
document.addEventListener('DOMContentLoaded', function () {
    const tabGroups = document.querySelectorAll('[data-tab-group]');

    function adjustPanelHeight(container, activePanel) {
        const newHeight = activePanel.offsetHeight;
        container.style.height = newHeight + 'px';
    }
    function addSwipeSupport(group, buttons, panels) {
        const panelContainer = group.querySelector('.tab-panels');
        let startX = 0;
        let endX = 0;
    
        panelContainer.addEventListener('touchstart', function (e) {
            startX = e.touches[0].clientX;
        });
    
        panelContainer.addEventListener('touchend', function (e) {
            endX = e.changedTouches[0].clientX;
            const diffX = endX - startX;

            if (Math.abs(diffX) > 50) {
                const activeIndex = [...buttons].findIndex(btn => btn.classList.contains('active'));
                let newIndex = activeIndex;

                if (diffX < 0 && activeIndex < buttons.length - 1) {
                    // swipe left → next tab
                    newIndex++;
                } else if (diffX > 0 && activeIndex > 0) {
                    // swipe right → previous tab
                    newIndex--;
                }

                if (newIndex !== activeIndex) {
                    buttons[newIndex].click(); // trigger the button click
                }
            }
        });
    }
    tabGroups.forEach(group => {
        const buttons = group.querySelectorAll('[data-tab-target]');
        const panels = group.querySelectorAll('[data-tab-id]');
        let current = group.querySelector('.tab-panel.active');
        adjustPanelHeight(group.querySelector('.tab-panels'), current);

        buttons.forEach(button => {
            button.addEventListener('click', () => {
                const targetId = button.getAttribute('data-tab-target');
                const next = group.querySelector(`.tab-panel[data-tab-id="${targetId}"]`);

                if (!next || next === current) return;

                // Remove active button state
                buttons.forEach(btn => btn.classList.remove('active'));
                button.classList.add('active');

                // Animate out current
                const direction = [...panels].indexOf(next) > [...panels].indexOf(current)
                ? 'slide-out-left'
                : 'slide-out-right';

                current.classList.remove('active');
                current.classList.add(direction);

                // Reset outgoing panel after transition
                setTimeout(() => {
                current.classList.remove(direction);
                }, 500); // matches CSS transition duration

                // Animate in next
                next.classList.remove('slide-out-left', 'slide-out-right');
                next.classList.add('active');
                adjustPanelHeight(group.querySelector('.tab-panels'), next);

                current = next;
            });
        });
        addSwipeSupport(group, buttons, panels);
    });
    let resizeTimeout;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            tabGroups.forEach(group => {
            const container = group.querySelector('.tab-panels');
            const active = group.querySelector('.tab-panel.active');
            adjustPanelHeight(container, active);
            });
        }, 100); // adjust timing as needed
    });
    // Ensure first visible slide isn't cropped
    window.addEventListener('load', function () {
        tabGroups.forEach(group => {
            const container = group.querySelector('.tab-panels');
            const active = group.querySelector('.tab-panel.active');
            adjustPanelHeight(container, active);
        });
    });
});


// JS for conditionally styling an element based on the sibling that follows it
const classesToMatch = ['apply-bg-green', 'apply-bg-bronze', 'map-embed', 'site-footer'];
document.querySelectorAll('.full-width-section').forEach( el => {
    const next = el.nextElementSibling;

    if(next && classesToMatch.some(cls => next.classList.contains(cls))) {
        el.classList.add('no-bottom-radius');
    }
});


// Image switcher on product page also updates hidden form field
document.addEventListener("DOMContentLoaded", function () {
    const tabButtons = document.querySelectorAll(".image-switcher-tabs button");
    const tabPanels = document.querySelectorAll(".image-change-wrapper .tab-panel");

    tabButtons.forEach(button => {
        button.addEventListener("click", function () {
            const targetId = this.getAttribute("data-tab-target");

            // Update buttons and use data attribute for form retrieval
            tabButtons.forEach(btn => {
                btn.classList.remove("active");
                btn.setAttribute('data-selected', 'false');
            });
            this.classList.add("active");
            this.setAttribute('data-selected', 'true');
            let roomColour = this.getAttribute('data-room-colour');
            document.getElementById('room_colour').value = roomColour;

            // Update panels
            tabPanels.forEach(panel => {
                if (panel.getAttribute("data-tab-id") === targetId) {
                    panel.classList.add("active");
                } else {
                    panel.classList.remove("active");
                }
            });
        });
    });
});


// Create event listener so that selected elements can be added to a form
document.addEventListener('click', (event) => {
    let optionalExtrasField = document.getElementById('optional_extras');
    let selectedExtras = [];
    
    if(optionalExtrasField) {
        selectedExtras = optionalExtrasField.value ? JSON.parse(optionalExtrasField.value) : [];
    }
    
    if(event.target.closest('.optional-extra')) {
        // Get the clicked element
        let element = event.target.closest('.optional-extra');
        let label = element.getAttribute('data-optional-extra');

        // Check the current value of data-selected
        let isSelected = element.getAttribute('data-selected') === 'true';

        // Toggle the state and class using the negated value of isSelected
        element.setAttribute('data-selected', !isSelected);
        element.classList.toggle('selected', !isSelected);

        if(!isSelected) {
            selectedExtras.push(label);
        } else {
            selectedExtras = selectedExtras.filter(item => item !== label);
        }

        optionalExtrasField.value = JSON.stringify(selectedExtras);
    }
});


/** 
 * Custom event listeners to update the hidden form fields
 * on page load
 */
document.addEventListener('DOMContentLoaded', function() {
    // Set the product name into the form
    const selectedProduct = document.querySelector('[data-product-name]');
    if(selectedProduct) {
        let productName = selectedProduct.getAttribute('data-product-name');
        document.getElementById('product_name').value = productName;
    }

    // Set the product colour and update it when it's changed
    const defaultColour = document.querySelector('[data-room-colour][data-selected="true"]');
    if(defaultColour) {
        let roomColour = defaultColour.getAttribute('data-room-colour');
        document.getElementById('room_colour').value = roomColour;
    }
});


// JS for controlling the colour switcher on the product preview block
document.addEventListener("DOMContentLoaded", function () {
    let switcherBlocks = document.querySelectorAll('.image-switcher-preview');

    switcherBlocks.forEach(block => {
        let tabButtons = block.querySelectorAll(".image-preview-tabs button");
        let tabPanels = block.querySelectorAll(".image-preview-wrapper .tab-panel");

        tabButtons.forEach(button => {
            button.addEventListener("click", function () {
                let targetId = this.getAttribute("data-tab-target");

                // Update buttons in this block only
                tabButtons.forEach(btn => {
                    btn.classList.remove("active");
                });
                this.classList.add("active");

                // Update panels in this block only
                tabPanels.forEach(panel => {
                    if (panel.getAttribute("data-tab-id") === targetId) {
                        panel.classList.add("active");
                    } else {
                        panel.classList.remove("active");
                    }
                });
            });
        });
    });
});